import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Phone, Tag, Megaphone, LogOut } from 'lucide-react';
export function Sidebar() {
  const navigate = useNavigate();
  const handleLogout = () => {
    navigate('/login');
  };
  return <aside className="w-64 bg-white h-screen shadow-md flex flex-col" data-id="element-123">
      <div className="p-6 border-b border-border" data-id="element-124">
        <div className="flex items-center" data-id="element-125">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/rASzWmqwcDDuZDhxwztpuY/pasted-image.svg" alt="Logo" className="h-8 mr-2" data-id="element-126" />
          <h1 className="text-xl font-bold text-primary" data-id="element-127">ConecZapp</h1>
        </div>
      </div>
      <nav className="flex-1 py-6 px-3" data-id="element-128">
        <ul className="space-y-2" data-id="element-129">
          <li data-id="element-130">
            <NavLink to="/dashboard" className={({
            isActive
          }) => `flex items-center p-3 rounded-lg transition-colors ${isActive ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-131">
              <LayoutDashboard className="mr-3 h-5 w-5" data-id="element-132" />
              Dashboard
            </NavLink>
          </li>
          <li data-id="element-133">
            <NavLink to="/numbers" className={({
            isActive
          }) => `flex items-center p-3 rounded-lg transition-colors ${isActive ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-134">
              <Phone className="mr-3 h-5 w-5" data-id="element-135" />
              Números
            </NavLink>
          </li>
          <li data-id="element-136">
            <NavLink to="/lists" className={({
            isActive
          }) => `flex items-center p-3 rounded-lg transition-colors ${isActive ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-137">
              <Tag className="mr-3 h-5 w-5" data-id="element-138" />
              Listas
            </NavLink>
          </li>
          <li data-id="element-139">
            <NavLink to="/campaigns" className={({
            isActive
          }) => `flex items-center p-3 rounded-lg transition-colors ${isActive ? 'bg-primary text-white' : 'text-gray-600 hover:bg-gray-100'}`} data-id="element-140">
              <Megaphone className="mr-3 h-5 w-5" data-id="element-141" />
              Campanhas
            </NavLink>
          </li>
        </ul>
      </nav>
      <div className="p-4 border-t border-border" data-id="element-142">
        <button onClick={handleLogout} className="flex items-center text-gray-600 p-3 rounded-lg w-full hover:bg-gray-100 transition-colors" data-id="element-143">
          <LogOut className="mr-3 h-5 w-5" data-id="element-144" />
          Sair
        </button>
      </div>
    </aside>;
}